import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { changePassword, requestEmailChange } from '@/api/auth/authApi';

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export function useChangePasswordMutation(): UseMutationResult<void, Error, ChangePasswordInput> {
  return useMutation({
    mutationFn: function submitPasswordChange(input: ChangePasswordInput) {
      return changePassword(input.currentPassword, input.newPassword);
    },
  });
}

export interface RequestEmailChangeInput {
  currentPassword: string;
  newEmail: string;
}

export function useRequestEmailChangeMutation(): UseMutationResult<
  void,
  Error,
  RequestEmailChangeInput
> {
  return useMutation({
    mutationFn: function submitEmailChange(input: RequestEmailChangeInput) {
      return requestEmailChange(input.currentPassword, input.newEmail);
    },
  });
}
